import { FirstTimeBanner } from 'shared/components/SmbPage/FirstTimeBanner';
import { TBanner } from 'shared/types/carousel';

export const renderBanner = (banner: TBanner) => {
  switch (banner) {
    case 'firstTimeOnCian':
      return <FirstTimeBanner />;
    default:
      return null;
  }
};
